import { checkTier, EventRFeature, TierTeam } from "@eventr/common";
import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "../state/bound.store";
import { useIsSuperAdmin } from "./useIsSuperAdmin";

export const useHasFeature = (feature?: EventRFeature) => {
  const superAdmin = useIsSuperAdmin();
  const isSuperAdminEnabled = localStorage.getItem("superAdminEnabled") === "true";
  const { tier } = useBoundStore(
    useShallow((s) => ({
      tier: s.tier,
    })),
  );
  if (!feature) {
    return true; // If no feature is specified, assume access is granted
  }

  const hasPermission = checkTier(tier ?? TierTeam.id, feature);
  if (superAdmin && isSuperAdminEnabled) {
    return true;
  }

  return hasPermission;
};
